import React from 'react'
import { Redirect } from 'react-router-dom'

const MainProjects = () => <Redirect to='/projects/projects' />

export default MainProjects
